import { useEffect, useState } from 'react';
import { TimesheetReportSummary } from 'api/timesheets/reports/types';
import { logger } from 'services';

export const useTimesheetReportSummary = (summaryApi) => {
  const [isSummaryLoading, setIsSummaryLoading] = useState(true);
  const [reportSummary, setReportSummary] = useState<TimesheetReportSummary>();

  useEffect(() => {
    setIsSummaryLoading(true);
    summaryApi()
      ?.then((summary: TimesheetReportSummary) => {
        setReportSummary(summary);
        setIsSummaryLoading(false);
      })
      ?.catch((error) => {
        logger.error('Error in fetching report summary', { error });
      });
  }, [summaryApi]);

  return {
    reportSummary,
    isSummaryLoading,
  };
};
